const DataRetention = () => {
  return (
    <div className="mb-8">
      <h2 id="data-retention" className="text-2xl font-semibold mb-4">Data Retention</h2>
      <p className="mb-6">
        We will retain your personal information only for as long as is necessary for the purposes set out in this privacy policy. We will retain and use your information to the extent necessary to comply with our legal obligations, resolve disputes, and enforce our policies.
      </p>
      <p className="mb-6">
        If you wish to request that we no longer use your information to provide you services, contact us at our support email. We will retain and use your information to the extent necessary to comply with our legal obligations, resolve disputes, and enforce our policies.
      </p>
    </div>
  );
};

export default DataRetention;